if ( typeof LocalizationForm !== 'function' ) {
	class LocalizationForm extends HTMLElement {

		constructor(){

			super();

			this.selector = this.querySelector('[data-js-localization-form-button]');
			this.content = this.querySelector('[data-js-localization-form-content]');
			this.policyCountriesOnly = this.hasAttribute('data-policy-countries-only');
			this.activeCountryCode = this.querySelector('input[name="country_code"]')?.value;
			this.countryGroups = this.policyCountriesOnly ? [
				{ label: '', codes: ['NL'] },
				{ label: this.dataset.countryGroupDeBeAt, codes: ['DE', 'BE', 'AT'] },
				{ label: this.dataset.countryGroupWestEu, codes: ['CZ', 'FR', 'HU', 'IT', 'LU', 'PL', 'PT', 'SK', 'ES'] },
				{ label: this.dataset.countryGroupNorthEu, codes: ['DK', 'EE', 'FI', 'IE', 'LV', 'LT', 'SE'] },
				{ label: this.dataset.countryGroupSouthEastEu, codes: ['BG', 'HR', 'CY', 'GR', 'MT', 'RO', 'SI'] },
				{ label: this.dataset.countryGroupNonEuEurope, codes: ['AL', 'AD', 'BY', 'BA', 'FO', 'GI', 'GG', 'VA', 'IS', 'IM', 'JE', 'XK', 'LI', 'MD', 'MC', 'ME', 'MK', 'NO', 'SM', 'RS', 'SJ', 'CH', 'UA', 'GB'] }
			] : [];
			this.reopenCartAfterSubmit = this.hasAttribute('data-reopen-cart-after-submit');
			this.floatingContent = this.content.hasAttribute('popover') && typeof this.content.showPopover === 'function';
			this.positionHandler = this.positionFloatingContent.bind(this);

			if ( this.selector ) {

				if ( this.querySelector('[data-js-localization-form-insert-helper-content]') ) {
					
					this.selector.addEventListener('click', e=>{
						if ( ! this.classList.contains('populated') ) {
							this.classList.add('populate');
							this.populate();
						}
					})

				}

				if ( this.reopenCartAfterSubmit ) {
					this.content.addEventListener('click', e=>{
						if ( e.target.closest('button[name="country_code"]') ) {
							try {
								window.sessionStorage.setItem('krown-reopen-cart-after-localization', 'true');
							} catch ( error ) {
								console.log(error);
							}
						}
					});
				}

				this.selector.addEventListener('click', e=>{

					e.stopPropagation();
					e.preventDefault();

					document.querySelectorAll('localization-form').forEach(form=>{
						if ( form != this && form.content?.classList.contains('content-opened') ) {
							form.close();
						}
					});

					if ( ! this.content.classList.contains('content-opened') ) {

						this.content.classList.add('content-opened');
						e.currentTarget.setAttribute('aria-expanded', 'true');
						this.style.zIndex = 1000;

						if ( this.floatingContent ) {
							if ( ! this.content.matches(':popover-open') ) {
								this.content.showPopover();
							}
							this.positionFloatingContent();
							window.addEventListener('resize', this.positionHandler);
							document.addEventListener('scroll', this.positionHandler, true);
						} else {
							if ( this.content.getBoundingClientRect().y + this.content.offsetHeight + 55 > window.innerHeight ) {
								this.content.classList.add('invert-y');
							}
							if ( this.content.getBoundingClientRect().x + this.content.offsetWidth + 55 > window.innerWidth ) {
								this.content.classList.add('invert-x');
							}
						}

						this.onClickHandler = (()=>{
							if ( this.content.classList.contains('content-opened') ) {
								this.close();
							}
						}).bind(this);
						window.addEventListener('click', this.onClickHandler);

					} else {
						this.close();
					}

				});

				this.selector.addEventListener('keydown', e=>{
					if ( e.key === 'Enter' ) {
						if ( ! this.content.classList.contains('opened-with-tab') ) {
							this.content.classList.add('opened-with-tab');
							this.content.querySelectorAll('[data-js-localization-form-item]').forEach(elm=>{elm.setAttribute('tabindex', '0')});
						}
					}
				});

				this.addEventListener('keydown', e=>{
					if ( e.key === 'Escape' && this.content.classList.contains('content-opened') ) {
						e.preventDefault();
						this.close();
						this.selector.focus();
					}
				});

			}

		}

		close() {
			this.selector.setAttribute('aria-expanded', 'false');
			this.style.zIndex = 9;
			if ( this.floatingContent ) {
				window.removeEventListener('resize', this.positionHandler);
				document.removeEventListener('scroll', this.positionHandler, true);
				if ( this.content.matches(':popover-open') ) {
					this.content.hidePopover();
				}
				this.content.style.removeProperty('position');
				this.content.style.removeProperty('top');
				this.content.style.removeProperty('right');
				this.content.style.removeProperty('bottom');
				this.content.style.removeProperty('left');
				this.content.style.removeProperty('width');
				this.content.style.removeProperty('max-width');
				this.content.style.removeProperty('max-height');
			}
			this.content.classList.remove('content-opened', 'invert-x', 'invert-y', 'opened-with-tab');
			window.removeEventListener('click', this.onClickHandler);
		}

		positionFloatingContent() {
			if ( ! this.floatingContent || ! this.content.classList.contains('content-opened') ) {
				return;
			}

			const viewportPadding = 16;
			const dropdownGap = 8;
			const selectorRect = this.selector.getBoundingClientRect();
			const dropdownWidth = Math.min(320, window.innerWidth - viewportPadding * 2);
			const availableBelow = Math.max(0, window.innerHeight - selectorRect.bottom - dropdownGap - viewportPadding);
			const availableAbove = Math.max(0, selectorRect.top - dropdownGap - viewportPadding);
			const desiredHeight = Math.min(360, this.content.scrollHeight);
			const openBelow = availableBelow >= Math.min(desiredHeight, 192) || availableBelow >= availableAbove;
			const availableHeight = openBelow ? availableBelow : availableAbove;
			const dropdownHeight = Math.min(desiredHeight, availableHeight);
			const dropdownLeft = Math.min(
				Math.max(viewportPadding, selectorRect.right - dropdownWidth),
				window.innerWidth - viewportPadding - dropdownWidth
			);
			const dropdownTop = openBelow
				? selectorRect.bottom + dropdownGap
				: Math.max(viewportPadding, selectorRect.top - dropdownGap - dropdownHeight);

			Object.assign(this.content.style, {
				position: 'fixed',
				top: `${dropdownTop}px`,
				right: 'auto',
				bottom: 'auto',
				left: `${dropdownLeft}px`,
				width: `${dropdownWidth}px`,
				maxWidth: `${dropdownWidth}px`,
				maxHeight: `${availableHeight}px`
			});
		}

		appendCountryGroup(fragment, label, countryItems) {
			if ( label ) {
				const groupLabel = document.createElement('li');
				groupLabel.className = 'localization-form__group-label';
				groupLabel.setAttribute('role', 'presentation');
				groupLabel.textContent = new DOMParser().parseFromString(label, 'text/html').body.textContent;
				fragment.append(groupLabel);
			}

			countryItems.forEach(item=>{
				const countryItem = item.cloneNode(true);
				countryItem.querySelector('.localization-form__currency')?.remove();
				fragment.append(countryItem);
			});
		}

		populate() {
			fetch('?section_id=helper-localization-form').then(response=>response.text())
				.then(text => {
					const documentFragment = new DOMParser().parseFromString(text, 'text/html');
					let countryItems = Array.from(documentFragment.querySelectorAll('[data-js-localization-form-item]'))
						.filter(item=>item.querySelector('button[name="country_code"]'));
					if ( countryItems.length === 0 ) {
						throw new Error('No localization countries were returned.');
					}
					if ( this.policyCountriesOnly ) {
						const countryItemsByCode = new Map(countryItems.map(item=>[item.dataset.countryCode, item]));
						const groupedCountries = document.createDocumentFragment();
						const includedCountryCodes = new Set();

						this.countryGroups.forEach(group=>{
							const groupItems = group.codes
								.map(code=>countryItemsByCode.get(code))
								.filter(Boolean);
							if ( groupItems.length > 0 ) {
								this.appendCountryGroup(groupedCountries, group.label, groupItems);
								groupItems.forEach(item=>includedCountryCodes.add(item.dataset.countryCode));
							}
						});

						const activeCountryItem = countryItemsByCode.get(this.activeCountryCode);
						if ( activeCountryItem && ! includedCountryCodes.has(this.activeCountryCode) ) {
							this.appendCountryGroup(groupedCountries, this.dataset.countryGroupCurrent, [activeCountryItem]);
						}

						this.content.replaceChildren(groupedCountries);
					} else {
						this.content.innerHTML = countryItems.map(item=>item.outerHTML).join('');
					}
					this.classList.remove('populate');
					this.classList.add('populated');
					if ( this.floatingContent ) {
						this.positionFloatingContent();
					} else {
						if ( this.content.getBoundingClientRect().y + this.content.offsetHeight + 55 > window.innerHeight ) {
							this.content.classList.add('invert-y');
						}
						if ( this.content.getBoundingClientRect().x + this.content.offsetWidth + 55 > window.innerWidth ) {
							this.content.classList.add('invert-x');
						}
					}
				})
				.catch(e=>{
					this.classList.remove('populate');
					console.log(e);
				})
		}

	}

	if ( typeof customElements.get('localization-form') == 'undefined' ) {
		customElements.define('localization-form', LocalizationForm);
	}

}
